import { ModelBase } from '../../core/model/model-base';
import { LocalDate } from '../../core/model/local-date';
import { Money } from '../../core/model/money';

export class DirectDebit extends ModelBase {
  constructor() {
    super();
  }

  private _createdDate: LocalDate;
  private _exportDate: LocalDate;
  private _invoiceDueDate: LocalDate;
  private _transactionDate: LocalDate;

  amount: Money;
  unPaidAmount: number;
  invoiceNumber: string;
  invoiceId: string;
  payerNumber: string;
  paymentStatusCodeText: string;

  get createdDate(): LocalDate {
    return this._createdDate;
  }
  set createdDate(value: LocalDate) {
    this._createdDate = LocalDate.fromDate(value);
  }

  get exportDate(): LocalDate {
    return this._exportDate;
  }
  set exportDate(value: LocalDate) {
    this._exportDate = LocalDate.fromDate(value);
  }

  get invoiceDueDate(): LocalDate {
    return this._invoiceDueDate;
  }
  set invoiceDueDate(value: LocalDate) {
    this._invoiceDueDate = LocalDate.fromDate(value);
  }

  get transactionDate(): LocalDate {
    return this._transactionDate;
  }
  set transactionDate(value: LocalDate) {
    this._transactionDate = LocalDate.fromDate(value);
  }
}
